import { createBrowserHistory } from 'history';

/** Custom created history object for navigating routes outside components */
export const history = createBrowserHistory();
